var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"width-100-pr",domProps:{"innerHTML":_vm._s(_vm.block.data.text)}})}
var staticRenderFns = []

export { render, staticRenderFns }